module.exports = __webpack_public_path__ + "static/media/fases.7a86daa6.png";